module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av655-1f0ec6413d5bd108cc433127b3c33599.jpg";